import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
} from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import addresses from "services/addressService";

export const fetchAddress = createAsyncThunk(
	"vino/address/fetchList",
	async (_, { dispatch }) => {
		try {
			dispatch(showLoader());
			return await addresses.list();
		} catch (e) {
			console.error(e);
			dispatch(
				showMessage({
					message: "Error occurred while getting address",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const addressAdapter = createEntityAdapter({});

export const {
	selectAll: selectAddress,
	selectById: selectAddressById,
} = addressAdapter.getSelectors((state) => state.vino.address);

const addressSlice = createSlice({
	name: "vino/address",
	initialState: addressAdapter.getInitialState(),
	reducers: {},
	extraReducers: {
		[fetchAddress.fulfilled]: addressAdapter.setAll,
	},
});

export default addressSlice.reducer;
